export default (topics, slug) => {
  const topic = topics.filter((topic) => (topic.slug === slug))[0]
  return topic ? topic.value : ''
}
